/* unplugin-vue-components disabled */import script from "./RoleSkillPreviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleSkillPreviewCard.vue?vue&type=script&setup=true&lang=js"

import "./RoleSkillPreviewCard.vue?vue&type=style&index=0&id=f7334fbe&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7334fbe"]])

export default __exports__